import React, {useEffect, useMemo, useState} from 'react';
import {toLonLat} from 'ol/proj';
import {useDispatch, useSelector} from 'react-redux';

import SearchInput from './search-input.jsx';
import {
  SOURCE_TYPES,
  suggestSavedSearches,
  suggestSearchItemIds,
} from './util.js';
import {
  clearSearch,
  executeSearch,
  loadSearch,
  searchSingleItem,
} from '@explorer/actions/search';
import {getAvailableItemTypes} from '@explorer/selectors/item-types';
import {hydrateSearchGeometry} from '@explorer/util/granero-resolver';
import {trackEvent} from '@explorer/analytics';
import {useGetSavedSearchesQuery} from '@explorer/api/apiSlice.js';

const ConnectedSearchInput = ({}) => {
  const dispatch = useDispatch();

  const [inputValue, setInputValue] = useState('');

  const center = useSelector(state => state.map.center);
  const itemTypes = useSelector(getAvailableItemTypes)?.types;
  const searchName = useSelector(state => state.search.name);

  const {data: savedSearches} = useGetSavedSearchesQuery(undefined);

  const lonLatCenter = useMemo(() => toLonLat(center), [center]);

  useEffect(() => {
    setInputValue(searchName);
  }, [searchName]);

  const onSelect = async result => {
    if (result) {
      trackEvent('Search Result selected', {
        query: result.title,
        isSavedSearch: !!result.savedSearch,
        source: result.source,
        featureClass: result.suggestion?.__type,
      });

      if (result.source === SOURCE_TYPES.SAVED_SEARCHES) {
        const hydratedSearch = await hydrateSearchGeometry(result.savedSearch);
        dispatch(loadSearch(hydratedSearch));
      } else if (result.source === SOURCE_TYPES.ITEM_IDS) {
        dispatch(searchSingleItem(result.searchItem));
      } else {
        dispatch(executeSearch(result));
      }
    }
  };

  const onSuggestSavedSearches = query =>
    suggestSavedSearches(query, savedSearches);
  const onSuggestSearchItemIds = query =>
    suggestSearchItemIds(query, itemTypes);

  const handleOnClearInput = () => dispatch(clearSearch());

  return (
    <SearchInput
      center={lonLatCenter}
      onSelect={onSelect}
      onClearSearch={handleOnClearInput}
      suggestionsPromises={[onSuggestSavedSearches, onSuggestSearchItemIds]}
      inputValue={inputValue}
      onInputChange={setInputValue}
    />
  );
};

ConnectedSearchInput.propTypes = {};

export default ConnectedSearchInput;
